import { Modal } from "@mantine/core"
import type React from "react"
import { memo } from "react"
import { ReactComponent as PennyLogo } from "../../assets/icons/penny_logo.svg"

type ModalSignOutConfirmProps = {
  open: boolean
  onClose(): void
  onConfirm(): void
}

const ModalSignOutConfirm: React.FC<ModalSignOutConfirmProps> = ({ open, onClose, onConfirm }) => {
  return (
    <Modal
      overlayProps={{
        opacity: 0.25,
      }}
      size={400}
      centered
      withCloseButton={false}
      opened={open}
      onClose={onClose}
      styles={{
        body: {
          padding: "0px",
        },
        content: {
          borderRadius: "16px",
          background: "#FFF",
          boxShadow:
            "0px 4px 6px -2px rgba(0, 0, 0, 0.06), 0px 12px 16px -4px rgba(0, 0, 0, 0.10)",
        },
      }}
    >
      <div className="p-6 flex flex-col gap-y-6">
        <div className="flex flex-col gap-y-4 items-center text-center">
            <PennyLogo width={102} height={41} />

          <div className="flex flex-col gap-y-2">
            <span className="text-pn-body-emphasis text-pn_gray-950">
              Sign out of your account?
            </span>
            <span className="text-pn-callout-regular text-pn_gray-600">
              Are you sure you want to sign out? You'll need to log in again to access your account.
            </span>
          </div>
        </div>

        <div className="flex items-center gap-x-3">
          <button
            onClick={onClose}
            className="btn-secondary-lg w-full"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="btn-alert-lg w-full"
          >
            Sign Out
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default memo(ModalSignOutConfirm) 